import type { ConnectedServiceDto } from "../../../common/model/connectedServiceDto";
import type { ConnectedServiceName } from "../../../common/model/connectedServiceName";
import type { SyncStatus } from "../../../common/model/syncStatus";
import ConnectedServiceStatus from "./ConnectedServiceStatus";

export default class ConnectedService {
  constructor(
    public userId: string,
    public serviceUserId: string | null,
    public serviceName: ConnectedServiceName,
    public accessToken: string | null,
    public refreshToken: string | null,
    public tokenExpiresAt: Date | null,
    public status: ConnectedServiceStatus,
  ) {}

  public get formattedName(): string {
    return this.formatName(this.serviceName);
  }

  public isConnected(): boolean {
    return !!this.accessToken;
  }

  public synchronizationStatus(): SyncStatus {
    return this.status.synchronizationStatus();
  }

  public lastHighWaterMark(): number {
    return this.status.lastHighWaterMark();
  }

  public lastError(maxLength: number = 100): string {
    const errorMessage = this.status.lastError();
    if (errorMessage && errorMessage.length > maxLength) {
      return `${errorMessage.substring(0, maxLength)}...`;
    }
    return errorMessage || "";
  }

  private formatName(name: string): string {
    // Ensure the name is a string and is not empty
    if (typeof name !== "string" || name.length === 0) {
      return "";
    }
    // Capitalize the first letter and make the rest of the string lowercase
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  static fromDto(u: ConnectedServiceDto): ConnectedService {
    return new ConnectedService(
      u.userId,
      u.serviceUserId,
      u.serviceName,
      u.accessToken,
      u.refreshToken,
      u.tokenExpiresAt ? new Date(u.tokenExpiresAt) : null,
      ConnectedServiceStatus.fromDto(u.status),
    );
  }
}
